import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Container, fadeInUp } from './shared';
import { trackEvent, AnalyticsEvents } from '../../utils/analytics';

const FinalCTA: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="relative py-24 sm:py-32">
      <Container>
        <motion.div
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          className="glass-card relative overflow-hidden rounded-3xl px-8 py-16 text-center sm:px-16"
        >
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute left-1/2 top-0 h-[300px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-primary/25 blur-[120px]" />
          </div>

          <div className="relative">
            <h2 className="mx-auto max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
              {t('landing.finalCta.title')}
            </h2>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-brand-muted">
              {t('landing.finalCta.subtitle')}
            </p>

            <button
              onClick={() => {
                trackEvent(AnalyticsEvents.CTA_CLICK, { location: 'final_cta', target: '/demo' });
                navigate('/demo');
              }}
              className="group mx-auto mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-brand-button px-8 py-4 text-base font-semibold text-white shadow-glow transition-transform duration-300 hover:scale-[1.03]"
            >
              {t('landing.finalCta.cta')}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </button>
          </div>
        </motion.div>
      </Container>
    </section>
  );
};

export default FinalCTA;
